import { Injectable } from '@angular/core';
import {
  BaseService,
  HttpClient,
  HttpHeaders,
  HttpParams,
} from './base.service';
import { ISalesGoal } from '../shared/api';
import { AccountService } from './account.service';

@Injectable()
export class SalesGoalService extends BaseService<ISalesGoal> {
  constructor(accountService: AccountService, http: HttpClient) {
    super(accountService, http, 'salesGoal');
  }
}

export { ISalesGoal } from '../shared/api';
